import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Centrally Managed Infrastructure",
    text: "Deploy, monitor, and optimize all locations through a single cloud dashboard—no matter the scale.",
  },
  {
    image: SocImg,
    title: "Built-In Security Everywhere",
    text: "Every connection is protected by zero-trust principles, encrypted traffic, and access control by design.",
  },
  {
    image: MonitoringImg,
    title: "Scalable to Evolving Workloads",
    text: "Easily adapt to organizational growth, new device types, and emerging hybrid work models without re-architecting.",
  },
];
